export default "__VITE_ASSET__BJ4Lz6Xu__"